import React from 'react';
import PanelStatus from './PanelStatus';
import { Room } from '@/components/pages/kiosk/monitor';
import { useScreenConfiguration } from '@/contexts/ScreenConfigurationContext';

interface StaffMemberData {
  type: 'staff' | 'physician' | 'anesthesiologist';
  text: string;
  id: string;
  entityId: string;
  name: string;
  title: string;
  fullTitle: string;
  entryTime?: string;
  arrivedOnSite: string | null;
  timeOfDay: string;
}

interface PanelStatusWrapperProps {
  operatingRoom: Room;
  operationRooms: Room[];
  isPreOp?: boolean;
  isSuperAdmin?: boolean;
  isLiaison?: boolean;
  staffMode?: boolean;
  getStaffForRoom: (roomId: string) => StaffMemberData[];
  hasOtherStatuses?: boolean;
}

/**
 * Wrapper component for PanelStatus that provides consistent props
 * and eliminates duplicate code in MonitorContent
 */
const PanelStatusWrapper: React.FC<PanelStatusWrapperProps> = ({
  operatingRoom,
  operationRooms,
  isPreOp,
  isSuperAdmin,
  isLiaison,
  staffMode,
  getStaffForRoom,
  hasOtherStatuses = false,
}) => {
  const compactView = operationRooms.length > 3;
  const miniView = operationRooms.length > 8;
  const numberOfRooms = operationRooms.length;

  const { messagingScreen } = useScreenConfiguration();

  return (
    <PanelStatus
      operatingRoom={operatingRoom}
      compactView={compactView}
      allowWrap={true}
      miniView={miniView}
      numberOfRooms={numberOfRooms}
      isPreOp={isPreOp}
      isSuperAdmin={isSuperAdmin}
      messagingView={messagingScreen || isLiaison}
      staffMode={staffMode}
      roomStaff={getStaffForRoom(operatingRoom.id)}
      hasOtherStatuses={hasOtherStatuses}
    />
  );
};

export default PanelStatusWrapper;
